import React from 'react';
import Panel from './Panel.js';
import { PreviewWrapper } from './PreviewWrapper.js';
export const PhonePreview = (props) => (React.createElement(PreviewWrapper, { selected: props.selected, onClick: props.onClick },
    React.createElement("h1", null, "Phone call"),
    React.createElement("p", null, 
    // @ts-ignore
    props.phone.number)));
export const Phone = (props) => (React.createElement(Panel, { header: "Phone call" },
    "Number:",
    ' ',
    // @ts-ignore
    props.phone.number));
//# sourceMappingURL=Phone.js.map